export const iconFontAwesomeFilesFileExcel = (
	<i className="fa-solid fa-file-excel"></i>
);
